import { Box, Grid, Typography } from "@mui/material";

import PortfolioChartMenu from "./PortfolioChartMenu";
import React from "react";
import WalletList from "./WalletList";
import WalletTabs from "./WalletTabs";
import SelectValueBalance from "./SelectValueBalance";

function AdvancedTradeWallet({ handleGetWalletInfo }) {
  return (
    <Grid container maxHeight="1020px" overflow="auto" pr={2}>
      <Grid item xs={12} mb={1}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h5" color="text.main">
            Available Balance
          </Typography>

          <PortfolioChartMenu />
        </Box>
      </Grid>

      <Grid item xs={12} mb={1}>
        <SelectValueBalance />
      </Grid>

      <Grid item xs={12} mb={1}>
        <WalletTabs handleGetWalletInfo={handleGetWalletInfo} />
      </Grid>

      <Grid item xs={12}>
        <WalletList />
      </Grid>
    </Grid>
  );
}

export default AdvancedTradeWallet;
